<template>
    <div class="shopping-all m-scroll">
        <HeaderBar title="购物车">
            <span slot="right" @click="editCart" class="editCart" v-if="cart.length > 0">
                {{isEdit ? '完成' : '编辑'}}
            </span>
        </HeaderBar>
        <div class="shopping-main m-padding" @scroll="handleScroll($event)">
            <div class="gift-richmond" v-if="giftJson">
                <img class="dp" src="@/assets/lottery/dp-min.png" alt="">
                <div class="flex">
                    <div class="gift-goods">
                        <img :src="giftJson.pic" alt="">
                    </div>
                    <div class="gift-info">
                        <p class="van-multi-ellipsis--l2">{{giftJson.title}}</p>
                        <p>有效期:{{giftJson.start_date}} - {{giftJson.end_date}}</p>
                    </div>
                    <div class="gift-rule">x1</div>
                </div>
            </div>
            <div class="store-item m-padding" v-for="(item, index) in cart" :key="index">
                <div class="store-title van-hairline--bottom" :class="{'select-active' : select[index].select == true}"  @click="selectAll(index)">
                    <img src="@/assets/cart/xuanzhe_1@2x.png" alt="">
                    <img src="@/assets/cart/xuanzhe_2@2x.png" alt="">
                    {{item.shop.title}} 
                    <span>(共{{item.shop.cart.length}}件)</span>
                    <span class="m-mooby" v-show="item.is_presale == 1">预售</span>
                </div>
                <div class="shipping">
                    <div class="shipping-left">
                        <p>
                            <img src="@/assets/cart/tishi@2x.png" alt="">
                            <span @click="$router.push('/zh/city')">{{address.ename || '选择地址'}}</span>
                            <span v-if="item.shop.freight_template && item.shop.freight_template.free_shipping == 1  && item.is_presale == 0">
                                满${{item.shop.freight_template.money}}免运费，还差$
                                <countTo
                                :decimals='2'
                                :startVal='0'
                                :endVal='(item.shop.freight_template.money - select[index].selectPrice) >= 0 ? item.shop.freight_template.money - select[index].selectPrice : 0'
                                :duration='1500' />
                            </span>
                            <span v-if="item.shop.freight_template && item.shop.freight_template.free_shipping == 1 && item.is_presale == 1">
                                满${{item.shop.freight_template.presale_money}}免运费，还差$
                                <countTo
                                :decimals='2'
                                :startVal='0'
                                :endVal='(item.shop.freight_template.presale_money - select[index].selectPrice) >= 0 ? item.shop.freight_template.presale_money - select[index].selectPrice : 0'
                                :duration='1500' />
                            </span>
                            <span v-if="(!item.shop.freight_template || item.shop.freight_template.free_shipping == 0) && address">该地区暂无包邮优惠，点击地址切换城市</span>
                            <span v-if="!address">定位失败，点击选择城市查看包邮规则</span>
                        </p>
                        <div class="progress-bar" v-if="item.shop.freight_template && item.shop.freight_template.free_shipping == 1 && item.is_presale == 0">
                            <div class="progress-main">
                                <div class="progress"
                                :style="{'width': (select[index].selectPrice / item.shop.freight_template.money > 1 ? 1 : select[index].selectPrice / item.shop.freight_template.money) * 100 + '%'}">
                                </div>
                            </div>
                            <span>
                                <countTo
                                :startVal='0'
                                :endVal='(select[index].selectPrice / item.shop.freight_template.money > 1 ? 1 : select[index].selectPrice / item.shop.freight_template.money).toFixed(4) * 100'
                                :duration='1500' />
                                %
                            </span>
                        </div>
                        <div class="progress-bar" v-if="item.shop.freight_template && item.shop.freight_template.free_shipping == 1 && item.is_presale == 1">
                            <div class="progress-main">
                                <div class="progress"
                                :style="{'width': (select[index].selectPrice / item.shop.freight_template.presale_money > 1 ? 1 : select[index].selectPrice / item.shop.freight_template.presale_money) * 100 + '%'}">
                                </div>
                            </div>
                            <span>
                                <countTo
                                :startVal='0'
                                :endVal='(select[index].selectPrice / item.shop.freight_template.presale_money > 1 ? 1 : select[index].selectPrice / item.shop.freight_template.presale_money).toFixed(4) * 100'
                                :duration='1500' />
                                %
                            </span>
                        </div>
                    </div>
                    <div class="shipping-right" v-if="item.shop.freight_template && item.shop.freight_template.free_shipping == 1" @click="goBuy(item)">
                        去凑单
                        <img src="@/assets/cart/icon-choudan@2x.png" alt="">
                    </div>
                </div>
                <!-- 预计到仓 -->
                <div class="pre-tip" v-if="item.is_presale == 1">
                    <p>配送：</p>
                    <p>该商品预计{{batch.purchase_period + batch.order_period + batch.delivery_date}}个工作日到仓</p>
                </div>
                <div class="goods-list">
                    <van-swipe-cell v-for="(it, ind) in item.shop.cart" :key="it.goods_id + ind">
                        <div class="goods-item" :class="{'goods-active' : select[index].goods[ind].select}"
                        @click="goDetail(item, it)">
                            <div @click.stop="selectHandle(index, ind)">
                                <img src="@/assets/cart/xuanzhe_1@2x.png" alt="" class="goods-select">
                                <img src="@/assets/cart/xuanzhe_2@2x.png" alt="" class="goods-select">
                            </div>
                            <div class="haggle" v-if="it.bargain_user_goods_sku_id != 0 || it.live_user_join_id != 0">砍价商品</div>
                            <img v-if="it.goods_sku.image" :src="it.goods_sku.image.remote_url" alt="" class="goods-img">
                            <div class="goods-right">
                                <p> {{it.goods_info.name}}</p>
                                <div class="sku" v-if="it.bargain_user_goods_sku_id != 0 || it.live_user_join_id != 0">
                                    {{it.goods_sku.attr_symbol_string.split(',').join(' | ')}}
                                </div>
                                <div class="sku" v-else @click.stop="handleCartNoAnimat(it.goods_id, it.goods_sku.barcode, it.number, ind, it.id)">
                                    {{it.goods_sku.attr_symbol_string.split(',').join(' | ')}}
                                    <img src="@/assets/cart/gengduo@2x.png" alt="">
                                </div>
                                
                                <div class="total" @click.stop="">
                                    <span>${{(it.goods_sku.price - 0).toFixed(2)}}</span>
                                    <van-stepper 
                                        v-if="it.live_user_join_id == 0"
                                        v-model="it.number" 
                                        disable-input integer  
                                        @plus="changeNumber(1,it, index)" 
                                        @minus="changeNumber(2,it, index)" 
                                        :max="(it.bargain_user_goods_sku_id == 0 && !item.is_presale) ? it.goods_sku.sku_stock.stock : (it.bargain_user_goods_sku_id == 0 && item.is_presale)? 5 : it.bargain_user_goods_sku.bargain_goods_sku.buy_limit" 
                                        class="step-total" />
                                </div>
                            </div>
                        </div>
                        <p class="live_alt" v-if="it.live_user_join_id != 0">备注：直播砍价商品请在直播开启后购买</p>
                    </van-swipe-cell>
                </div>
            </div>
            <div v-if="invalid_sale.length != 0">
                <!-- <div class="invalid-title">无效商品</div> -->
                <div class="invalid m-padding">
                    <div class="mask"></div>
                    <div v-for="(item,index) in invalid_sale" :key="index" class="invalid_goods">
                        <div class="">
                            <img v-if="item.goods_sku.image" :src="item.goods_sku.image.remote_url" alt="">
                            <p class="van-multi-ellipsis--l2">{{item.goods_info.name}}</p>
                        </div>
                    </div>
                </div>
                <div class="clear">
                    <span @click="delInvalid">
                        清空无效商品
                    </span>
                </div>
            </div>

            <!-- 缺省图 -->
            <img v-if="cart.length <= 0" src="@/assets/cart/cart_empty.png" alt="" class="cart-img">
            <p v-if="cart.length <= 0" class="cart-no">“购物车这么空，快去填满它~”</p>

            <!-- 为您推荐 -->
            <m-divider title="为您推荐" class="m-cat-devider" v-if="!isEdit"></m-divider>
            <goods-columns @cartClick="handleCart" :data="remGoodsList" class="m-cat-padding" v-if="!isEdit"></goods-columns>
            <p v-if='noMore' style="line-height:80px;text-align:center;color:#888;font-size:14px">暂无更多商品</p>  

            <van-loading v-show="loading" type="spinner" color="#ED2A24" size="6.4vw" v-if="!isEdit"></van-loading>
        </div>
        <div class="cart-tools noselect van-hairline--top" :class="{'edit-cart': isEdit, 'cart-tools-delay' : !isEdit}">
            <div class="price">合计：${{ allTotal.toFixed(2) }}</div>
            <div class="calc-order" @click="orderSubmit">提交订单</div>
        </div>
        <div class="cart-tools cart-tools-del noselect van-hairline--top" :class="{'edit-cart-delete': isEdit, 'cart-tools-delay' : isEdit}">
            <div class="price"></div>
            <div class="calc-order" @click="delCartHandle">删除选中</div>
        </div>

        <!-- 选择SKU 加入购物车 -->
        <m-sku :title="skuTitle" :show="skuModal" @close="val => skuModal=val" @success="handleCartSuccess" :goodsId.sync='goodsId'
        :barcode.sync="goodsBarCode" :num.sync="goodsNum" @edit="changeSku"></m-sku>

        <!-- 加入购物车动画 -->
        <m-animate :start="start" :dom="start_dom" @end="handleCartEnd"></m-animate>

        <footer-bar />
    </div>
</template>

<script>
import HeaderBar from '@/components/zh/header-bar.vue'
import FooterBar from '@/components/zh/footer-bar.vue'
import MSku         from '@/components/zh/m-sku.vue'
import MAnimate     from '@/components/zh/cart-animate.vue'
import GoodsColumns from '@/components/zh/goods-columns.vue'
import MDivider     from '@/components/zh/m-divider.vue'
import { getBatch } from '@/api/public.js'
import { add } from '@/untils/js/common.js'
import countTo from 'vue-count-to'
import '@/untils/js/geocoder.js'
import { getCartRemGoods, getCart, subCart, updateCart, delCart, updateSku, del_invalid } from '@/api/zh/cart.js'
import {  is_gift } from '@/api/zh/index.js'
import { favoriteGoods } from '@/api/zh/mine.js'
export default {
    components: { FooterBar, HeaderBar, MSku, MAnimate, GoodsColumns,  MDivider, countTo 
    },
    data() {
        return {
            giftJson    : '',
            value       : '1',
            invalid_sale: [],   // 无效商品
            normal_sale : [],   // 正常商品
            pre_sale    : [],   // 预售商品
            cart        : [],    // 购物车数据
            select      : [],
            isEdit      : false,
            editSelect  : [],  // 购物车 编辑时 选择状态存放
            remGoodsList: [],  // 为你推荐数据
            start       : false,      // 是否开启加入购物车动画
            start_dom   : null,   // 开启动画的起点DOM 
            skuModal    : false,    // 控制显示 选择sku加入购物车面板
            loading     : false,
            startAnimat : false, // 是否开启加入购物车动画
            page        : 1,
            noMore      : false,
            address     : {},
            goodsId     : '',
            nowAddress  : '', // 定位地址
            goodsBarCode: '',
            goodsNum    : 1,
            skuTitle    : '加入购物车',
            skuIndex    : 0,
            cartId      : '',
            allTotal    : 0,
            isAddCart   : false,
            batch: {},
            dialogRichmond: false 
        }
    },
    methods: {
        handleScroll(e){
            if(e.target.scrollHeight - e.target.clientHeight- e.target.scrollTop <= 50){
                if(!this.islock && !this.noMore){
                    e.preventDefault()
                    e.stopPropagation()
                    this.loading = true
                    this.page++
                    this.getCartRemGoodsHandle()
                }
            }
        },
        // 清空无效
        delInvalid() {
            del_invalid().then(res => {
                if(res) {
                    this.getCartHandle()
                    this.$notify({ type: 'success', message: 'success' })
                }
            })
        },
        Gift() {
            is_gift().then(res => {  
                if(res){
                    this.giftJson = res.data;
                }
            })
        },
        editCart() {
            // 编辑
            if(this.cart.length > 0) {
                this.isEdit = !this.isEdit
            } else {
                this.isEdit = false
            }
        },
        selectHandle(index, ind) {
            // 选择规格
            if(this.select[index].goods[ind].buy_status != 0) {
                this.select[index].goods[ind].select = !this.select[index].goods[ind].select
                this.allTotal = add(this.allTotal, (this.select[index].goods[ind].select ? 1 : -1) * this.select[index].goods[ind].goods_sku.price * this.select[index].goods[ind].number)
                // // 循环遍历  如果该index下全部选中则 全部选中按钮  全部选中
                let allSelect = true
                this.select[index].selectPrice = 0
                this.select[index].goods.forEach(el => {
                    if(!el.select) {
                    allSelect = false
                    } else {
                        this.select[index].selectPrice += el.goods_sku.price * el.number
                    }
                })
                if(!allSelect) {
                    this.select[index].select = false
                }else{
                    this.select[index].select = true
                }
            }
            
        },
        selectAll(index) {
            // 选择全部
            this.select[index].selectPrice = 0
            if(!this.select[index].select) {
                this.select[index].select = true
                // this.select[index].selectPrice = this.cart[index].total_price
                this.select[index].goods.forEach( (el,ind) => {
                    if(el.buy_status != 0) {
                        this.allTotal = add(this.allTotal, (el.select ? 0 : 1) * this.select[index].goods[ind].goods_sku.price* this.select[index].goods[ind].number)
                        this.select[index].selectPrice += this.select[index].goods[ind].goods_sku.price* this.select[index].goods[ind].number
                        el.select = true
                    }
                })
            }else{
                this.select[index].select = false
                this.select[index].selectPrice = 0
                this.select[index].goods.forEach( (el,ind) => {
                    this.allTotal = add(this.allTotal, (el.select ? -1 : 0 ) * this.select[index].goods[ind].goods_sku.price * (this.select[index].goods[ind].number))
                    el.select = false
                })
            }
        },
        goDetail(item, it) {
            // 判断跳转bargain_user_goods_sku_id 是否为0  为0跳转正常商品详情  反之跳转砍价详情
            if(it.bargain_user_goods_sku_id == 0 && it.live_user_join_id == 0) {
                this.$router.push({path:`/zh/goods/detail/${it.goods_id}`, query: {pre: item.is_presale == 1 ? 1 : 0}})
            } else if(it.live_user_join_id != 0) {
                this.$router.push({path:`/liveDetail/${it.goods_id}`,query:{haggle_id:it.live_user_join_id}})
            } else {
                this.$router.push({path:`/zh/haggleDetail/${it.goods_id}`,query:{haggle_id:it.bargain_user_goods_sku_id}})
            }
        },
        calcPrice() {
            // 计算价格

        },
        handleCart(goods, e){
            // 商品列表购物车点击事件
            this.skuTitle    = '加入购物车'
            this.goodsId     = goods
            this.skuModal    = true
            this.start_dom   = e 
            this.startAnimat = true
            this.isAddCart   = true
            this.getCartHandle();
        },
        handleCartNoAnimat(goods, barcode, num, index, id) {
            // 加入购物车  无动画
            this.skuTitle     = '修改规格'
            this.goodsBarCode = barcode
            this.goodsNum     = num
            this.goodsId      = goods
            this.skuIndex     = index
            this.cartId       = id
            this.skuModal     = true
            this.startAnimat  = false
            this.isAddCart    = false
        },
        handleCartSuccess(){
            // sku 弹窗加入购物车成功回调
            this.skuModal = false
            if(this.startAnimat) {
                let timer = setTimeout( () => {
                    this.start = true

                    // 重新获取购物车
                    if(this.isAddCart) {
                        this.getCartHandle()
                    }
                    clearTimeout(timer)
                },300)
            }        
        },
        handleCartEnd(){
            // 加入购物车动画结束
            this.start = false
        },
        getCartRemGoodsHandle() {
            // 获取推荐的商品
            this.islock   = true
            getCartRemGoods({page: this.page}).then(res => {
                this.loading  = false
                this.islock   = false
                if(res) {
                    this.remGoodsList = this.remGoodsList.concat(res.data.data)
                }else{
                    this.noMore = true
                }
            })
        },
        // 添加喜欢列表
        addFavoriteHandle(id) {
            favoriteGoods(id, {status: 1}).then(res => {
                if(res) {
                    this.$notify({ type: 'success', message: res.msg})
                    this.getCartHandle()
                }
            }).catch(() => {
                this.$notify({ type: 'warning', message: 'Already exists'})
            })
        },
        getCartHandle() {
            // 获取购物车数据  {city: this.address ? this.address.split(' ').join('') : null}
            this.$store.commit('load')
            getCart({city: this.address.ename,province:this.address.pname}).then(res => {
                if(res.code == 20000) {
                    this.invalid_sale = res.data.invalid_sale
                    this.normal_sale = res.data.normal_sale
                    this.normal_sale.forEach(item =>{
                        item.is_presale = 0
                    })
                    this.pre_sale = res.data.pre_sale
                    this.pre_sale.forEach(item =>{
                        item.is_presale = 1
                    })
                    this.cart = [...this.normal_sale, ...this.pre_sale]
                    this.allTotal = 0
                    this.select = []
                    this.cart.forEach( el => {
                        el.shop.cart.forEach( ele => {
                            this.$set(ele,'select',false)
                        })
                        this.select.push({storeId: el.shop.id, select: false, goods: el.shop.cart, selectPrice: 0})
                    })
                    this.$forceUpdate()
                } else {
                    this.allTotal = 0
                }
            }).catch(() => {
                this.cart = []
            }).finally(() => {
                this.$store.commit('unload')
            })
        },

        // 更改购物车数量
        changeNumber(type,it, index) {
            let num = 0
            if(type == 1) {
                num = it.number + 1
            }else {
                num = it.number - 1
            }
            updateCart(it.id, {buy_number: num}).then(res => {
                if(res) {
                    this.getCartHandle()
                    if(type == 1) {
                        this.$store.commit('addCart')
                    }else {
                       this.$store.commit('delCart')
                    }
                    if(it.select) {
                        this.select[index].selectPrice += (type == 1 ? 1 : -1) * it.goods_sku.price
                        this.selectTotal += (type == 1 ? 1 : -1) * it.goods_sku.price
                    }
                    // this.select[index].goods.forEach( (el,ind) => {
                    //     if(el.select) {
                    //         this.allTotal += (type == 1 ? 1 : -1) * this.select[index].goods[ind].goods_sku.price 
                    //     }
                    // })
                    
                    this.$notify({ type: 'success', message: res.msg, })
                }else {
                    if(type == 1) {
                        it.number --
                    }else {
                        it.number ++
                    }
                }
            })
        },
        changeSku(sku) {
            updateSku(this.cartId, {barcode: sku.barcode}).then(res => {
                if(res) {
                    this.$notify({ type: 'success', message: res.msg, })
                    this.getCartHandle()
                    this.skuModal = false
                }else{
                    this.$notify({ type: 'warning', message: res.msg, })
                }
            })
        },
        delCartHandle(e) {
            // 删除购物车
            let arr = []
            if(e.target) {
                e.target.classList.add('calc-order-scale')
                setTimeout(() => {
                    e.target.classList.remove('calc-order-scale')
                }, 150)
                this.select.forEach(e => {
                    e.goods.forEach(el => {
                        if(el.select) {
                            arr.push(el.id)
                        }
                    })
                })
            } else {
                arr.push(e)
            }
            
            if(arr.length == '') {
                this.$notify({ type: 'warning', message: '请选择商品' })
                return false
            }
            let params = {
                ids: arr.join(',')
            }

            delCart(params).then(res => {
                if(res.code == 20000) {
                    this.$notify({ type: 'primary', message: res.msg })
                    this.getCartHandle()
                    this.isEdit = false
                    this.select.forEach(el => {
                        el.select = false
                        el.goods.forEach( ele => {
                            this.$set(ele, 'select', false)
                        })
                    })
                } else {
                    this.$notify({ type: 'warning', message: res.msg })
                }
            })
        },
        // 提交订单
        orderSubmit(e) {
            e.target.classList.add('calc-order-scale')
            setTimeout(() => {
                e.target.classList.remove('calc-order-scale')
            }, 150)

            let arr = []
            this.select.forEach(e => {
                e.goods.forEach(el => {
                    if(el.select) {
                        arr.push(el.id)
                    }
                })
            })
            if(arr.length == '') {
                this.$notify({ type: 'warning', message: '请选择商品' })
                return false
            }
            let params = {
                ids: arr.join(',')
            }
            subCart(params).then(res => {
                if(res) {
                    this.$router.push('/zh/payment')
                }
            })
        },
        getBatchHandle() {
            // 获取批次时间
            getBatch().then(res => {
                if(res) {
                    this.batch = res.data
                }
            })
        },
        goBuy(data) {
            // 去凑单
            if(data.is_presale == 1 && data.shop.id == 1) {
                // 预售模块
                this.$router.push(`/zh/presale?id=6`)
            } else {
                // 跳转店铺
                this.$router.push(`/zh/mooby?id=4`)
            }
        }
    },
    created() {
        // let queryStr = window.location;
        // if (this.$store.state.isMiniProgram) {
        //     window.wx.miniProgram.navigateTo({ url: "/pages/map/map?returnUrl=" + queryStr })
        // }
        // 从本低存储中获取数据
        if(sessionStorage.getItem('geo_address')) {
            this.address = JSON.parse(sessionStorage.getItem('geo_address'))
        }
        this.Gift();
        this.getCartHandle()
        this.getCartRemGoodsHandle()
        this.$store.dispatch('getCart')
        this.getBatchHandle()
    },
    mounted() {
        let timer = setInterval(() => {
            if(this.$store.state.city != null) {
                let city = this.$store.state.city
                if(city) {
                    if(!this.address) {
                        this.address = city
                        sessionStorage.setItem('geo_address', JSON.stringify(city))
                    }
                }
                clearInterval(timer)
            }
        }, 500)
    },
    // watch: {
    //     '$route' () {
    //          if (window.location.search) {
    //             let searchStr = window.location.search;
    //             searchStr = searchStr.substring(1, searchStr.length);
    //             let searchArr = searchStr.split("&"); // 分割成字符串数组
    //             console.log(searchArr);  
    //         }
    //     }
    // }
}
</script>

<style scoped lang="less">
@import './index.less';
</style>

<style lang="less">
.shopping-all{
    .step-total{width:80px;height:20px;margin-right:-10px;
        button,input{height:100%;border-radius: 0}
        input{border:1px solid rgba(230,230,230,1);background-color: #fff;margin:0}
        button{width:20px;background-color: rgba(230,230,230,1)}
    }
    .m-cat-padding{padding:0}
    .m-cat-devider{
        margin:15px 0;
        font-size:18px;
        font-weight:500;
        color:rgba(15,30,51,1);
    }

    .pre-tip{display: flex;border-top:1px solid #f7f7f7;border-bottom:1px solid #f7f7f7;padding: 10px 0;
        p{font-size: 12px;color:#888;line-height: 20px;
            &:nth-of-type(1){width: 40px;}
        }
    }
    .cart-img {
        width:80%;
        margin:50px auto 20px auto;
        display:block;
        padding-left:5%;
    }
    .cart-no {
        margin-bottom:100px;
        text-align:center;
        font-size:14px;
        color:#888;
    }
    .invalid {
        border-radius: 8px;
        background: #fff;
        position: relative;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(231, 231, 231, 0.4);
            border-radius: 8px;
        }
        .invalid_goods {
            padding: 8px 0;
            >div {
                color: #666;
                display: flex;
                align-items: center;
                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 15px;
                    flex-shrink:0;
                }
            }
        }
    }
    .invalid-title {
        text-align: center;
        color: #666;
        margin-bottom: 5px;
    }
    .clear {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        span {
            padding: 2px 10px;
            border: 1px solid #333;
            border-radius: 10px;
            font-size: 12px;
        }
    }
}
</style>
